export const isItemHandled = (row) => Boolean(
  row?.handling_action || row?.order_item?.returned_to_storage || row?.order_item?.left_in_vehicle
);

export const itemHandlingDestination = (row) =>
  row?.handling_storage?.title || row?.order_item?.storage?.title;
